export default [
  {
    component: () => import("@/components/rh/MenuRH.vue"),
    name: "rh",
    label: "RH",
    path: "/rh",
  },
  {
    component: () => import("@/components/rh/SubmenuRHCadastros.vue"),
    name: "rh.cadastros",
    path: "/rh/cadastros",
    label: "Cadastros",
  },
  {
    component: () => import("@/components/rh/ViewRHCadastrosFuncionarios.vue"),
    name: "rh.cadastros.funcionarios",
    path: "/rh/cadastros/funcionarios",
    label: "Visualizar Funcionários",
  },
  {
    component: () => import("@/components/rh/FormFuncionario.vue"),
    name: "rh.cadastros.funcionarios.novo",
    label: "Cadastrar Funcionário",
    path: "/rh/cadastros/funcionarios/novo",
  },
  {
    component: () => import("@/components/rh/FormFuncionario.vue"),
    name: "rh.cadastros.funcionarios.editar",
    label: "Editar Funcionário",
    path: "/rh/cadastros/funcionarios/:id/editar",
  },
  {
    component: () => import("@/components/rh/ViewRHCadastrosFuncoes.vue"),
    name: "rh.cadastros.funcoes",
    path: "/rh/cadastros/funcoes",
    label: "Visualizar Funções",
  },
  {
    component: () => import("@/components/rh/ViewRHCadastrosFuncoes.vue"),
    name: "rh.cadastros.funcoes.novo",
    path: "/rh/cadastros/funcoes/novo",
    label: "Cadastrar Funções",
  },
  {
    component: () => import("@/components/rh/ViewRHCadastrosDepartamentos.vue"),
    name: "rh.cadastros.departamentos",
    path: "/rh/cadastros/departamentos",
    label: "Departamentos",
  },
  {
    component: () => import("@/components/rh/ViewRHCadastrosJornadas.vue"),
    name: "rh.cadastros.jornadas",
    path: "/rh/cadastros/jornadas",
    label: "Jornadas de Trabalho",
  },
  {
    component: () => import("@/components/rh/FormDepartamento.vue"),
    name: "rh.cadastros.departamentos.novo",
    path: "/rh/cadastros/departamentos/novo",
    label: "Novo Departamento",
  },
  {
    component: () => import("@/components/rh/FormDepartamento.vue"),
    name: "rh.cadastros.departamentos.editar",
    path: "/rh/cadastros/departamentos/:id/editar",
    label: "Editar Departamento",
  },

  // Controle de Ponto
  {
    component: () => import("@/components/rh/ponto/ViewRHPontoInconsistencias.vue"),
    name: "rh.ponto.inconsistencias",
    path: "/rh/ponto/inconsistencias",
    label: "Tratamento de Ponto",
  },
  {
    component: () => import("@/components/rh/ponto/ViewRHPontoFechamento.vue"),
    name: "rh.ponto.fechamento",
    path: "/rh/ponto/fechamento",
    label: "Fechamento Mensal",
  },

  // Recrutamento e Seleção (ATS)
  {
    component: () => import("@/components/rh/recrutamento/ViewRHRecrutamentoVagas.vue"),
    name: "rh.recrutamento.vagas",
    path: "/rh/recrutamento/vagas",
    label: "Vagas",
  },
  {
    component: () => import("@/components/rh/recrutamento/FormRHRecrutamentoVaga.vue"),
    name: "rh.recrutamento.vagas.nova",
    path: "/rh/recrutamento/vagas/nova",
    label: "Nova Vaga",
  },
  {
    component: () => import("@/components/rh/recrutamento/FormRHRecrutamentoVaga.vue"),
    name: "rh.recrutamento.vagas.editar",
    path: "/rh/recrutamento/vagas/:id/editar",
    label: "Editar Vaga",
  },
  {
    component: () => import("@/components/rh/recrutamento/ViewRHRecrutamentoPipeline.vue"),
    name: "rh.recrutamento.pipeline",
    path: "/rh/recrutamento/vagas/:id/pipeline",
    label: "Pipeline de Candidatos",
  },

  {
    component: () => import("@/components/rh/recrutamento/ViewRHRecrutamentoCandidatos.vue"),
    name: "rh.recrutamento.candidatos",
    path: "/rh/recrutamento/candidatos",
    label: "Banco de Talentos",
  },

  // KPIs e Desempenho
  {
    component: () => import("@/components/rh/kpi/ViewRHKpiIndicadores.vue"),
    name: "rh.kpi.indicadores",
    path: "/rh/kpi/indicadores",
    label: "Biblioteca de Indicadores",
  },
  {
    component: () => import("@/components/rh/kpi/ViewRHKpiCiclos.vue"),
    name: "rh.kpi.ciclos",
    path: "/rh/kpi/ciclos",
    label: "Ciclos de Avaliação",
  },
  {
    component: () => import("@/components/rh/kpi/ViewRHKpiMetas.vue"),
    name: "rh.kpi.metas",
    path: "/rh/kpi/ciclos/:id/metas",
    label: "Distribuição de Metas",
  },
  {
    component: () => import("@/components/rh/kpi/ViewRHKpiDashboard.vue"),
    name: "rh.kpi.dashboard",
    path: "/rh/kpi/dashboard",
    label: "Painel de Acompanhamento",
  },
  {
    component: () => import("@/components/rh/kpi/ViewRHKpiAlertas.vue"),
    name: "rh.kpi.alertas",
    path: "/rh/kpi/alertas",
    label: "Alertas de Desempenho",
  },

  // Pesquisa Organizacional
  {
    component: () => import("@/components/rh/pesquisa/ViewRHPesquisaTemplates.vue"),
    name: "rh.pesquisa.templates",
    path: "/rh/pesquisa/templates",
    label: "Templates de Pesquisa",
  },
  {
    component: () => import("@/components/rh/pesquisa/FormRHPesquisaTemplate.vue"),
    name: "rh.pesquisa.templates.novo",
    path: "/rh/pesquisa/templates/novo",
    label: "Novo Template",
  },
  {
    component: () => import("@/components/rh/pesquisa/FormRHPesquisaTemplate.vue"),
    name: "rh.pesquisa.templates.editar",
    path: "/rh/pesquisa/templates/:id/editar",
    label: "Editar Template",
  },
  {
    component: () => import("@/components/rh/pesquisa/ViewRHPesquisaGerenciar.vue"),
    name: "rh.pesquisa.gerenciar",
    path: "/rh/pesquisa/gerenciar",
    label: "Gerenciar Pesquisas",
  },
  {
    component: () => import("@/components/rh/pesquisa/ViewRHPesquisaResultados.vue"),
    name: "rh.pesquisa.resultados",
    path: "/rh/pesquisa/:id/resultados",
    label: "Resultados da Pesquisa",
  },

  // Dashboard — todos os paths começam com /rh/dashboard (prefixo do pai)
  {
    component: () => import("@/components/rh/dashboard/ViewRHDashboard.vue"),
    name: "rh.dashboard",
    path: "/rh/dashboard",
    label: "Dashboard",
  },
  {
    component: () => import("@/components/rh/dashboard/ViewRHOrganograma.vue"),
    name: "rh.dashboard.organograma",
    path: "/rh/dashboard/organograma",
    label: "Organograma",
  },

  // Férias e Afastamentos — todos os paths começam com /rh/ferias (prefixo do pai)
  {
    component: () => import("@/components/rh/ferias/SubmenuRHFerias.vue"),
    name: "rh.ferias",
    path: "/rh/ferias",
    label: "Férias e Afastamentos",
  },
  {
    component: () => import("@/components/rh/ferias/ViewRHFeriasControle.vue"),
    name: "rh.ferias.controle",
    path: "/rh/ferias/controle",
    label: "Controle de Férias",
  },
  {
    component: () => import("@/components/rh/ferias/ViewRHFeriasCalendario.vue"),
    name: "rh.ferias.calendario",
    path: "/rh/ferias/calendario",
    label: "Calendário de Equipe",
  },
  {
    component: () => import("@/components/rh/ferias/ViewRHFeriasAfastamentos.vue"),
    name: "rh.ferias.afastamentos",
    path: "/rh/ferias/afastamentos",
    label: "Atestados e Licenças",
  },
  {
    component: () => import("@/components/rh/ferias/ViewRHFeriasAfastamentos.vue"),
    name: "rh.ferias.afastamentos.novo",
    path: "/rh/ferias/afastamentos/novo",
    label: "Novo Afastamento",
  },
  {
    component: () => import("@/components/rh/ferias/ViewRHFeriasSolicitacoes.vue"),
    name: "rh.ferias.solicitacoes",
    path: "/rh/ferias/solicitacoes",
    label: "Solicitações de Férias",
  },

  // Recrutamento e Seleção (ATS)
  {
    component: () => import("@/components/rh/recrutamento/ViewRHRecrutamentoVagas.vue"),
    name: "rh.recrutamento.vagas",
    path: "/rh/recrutamento/vagas",
    label: "Vagas",
  },
  {
    component: () => import("@/components/rh/recrutamento/FormRHRecrutamentoVaga.vue"),
    name: "rh.recrutamento.vagas.nova",
    path: "/rh/recrutamento/vagas/nova",
    label: "Nova Vaga",
  },
  {
    component: () => import("@/components/rh/recrutamento/FormRHRecrutamentoVaga.vue"),
    name: "rh.recrutamento.vagas.editar",
    path: "/rh/recrutamento/vagas/:id/editar",
    label: "Editar Vaga",
  },
  {
    component: () => import("@/components/rh/recrutamento/ViewRHRecrutamentoPipeline.vue"),
    name: "rh.recrutamento.pipeline",
    path: "/rh/recrutamento/vagas/:id/pipeline",
    label: "Pipeline de Candidatos",
  },
  {
    component: () => import("@/components/rh/recrutamento/ViewRHRecrutamentoCandidatos.vue"),
    name: "rh.recrutamento.candidatos",
    path: "/rh/recrutamento/candidatos",
    label: "Banco de Talentos",
  },
];
